export const BRAND_OPTIONS = [
  { label: 'Wayfair', value: 'wayfair' },
  { label: 'Four Hands', value: 'fourhands' },
  { label: 'Dovetail', value: 'dovetail' },
  { label: 'Sunset West', value: 'sunsetwest' },
  { label: 'Visual Comfort', value: 'visualcomfort' },
  { label: 'Currey & Co', value: 'curreycompany' },
];

export const DIRECT_BRANDS_EXCLUDE = ['wayfair', 'Wayfair'];

export function getBrandFilterOptions(directBrandsOnly) {
  const excludeSet = new Set(DIRECT_BRANDS_EXCLUDE.map((b) => b.toLowerCase()));
  const items = directBrandsOnly
    ? BRAND_OPTIONS.filter((opt) => !excludeSet.has(opt.value.toLowerCase()))
    : [...BRAND_OPTIONS];
  return {
    label: 'Brand',
    items,
  };
}

/**
 * Normalize product vendor/from/brand for comparison.
 * @param {object} product - product with vendor, from, or brand
 * @returns {string} lowercase value
 */
export function getProductBrandValue(product) {
  const raw = product?.vendor || product?.from || product?.brand || '';
  return String(raw).toLowerCase().trim();
}

/**
 * Check if a product passes the brand filter (for client-side filtering).
 * @param {object} product
 * @param {{ from?: string, excludeFrom?: string }} filter - from = comma-separated allowed brands, excludeFrom = comma-separated excluded
 * @returns {boolean}
 */
export function productMatchesBrandFilter(product, filter) {
  const value = getProductBrandValue(product);
  if (!value) return true;

  const excludeFrom = (filter.excludeFrom || '')
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
  if (excludeFrom.length && excludeFrom.includes(value)) return false;

  const from = (filter.from || '')
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
  if (from.length && !from.includes(value)) return false;

  return true;
}
